import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getIcon } from 'styles/icons';
import { getColor, Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const ModalWrapper = styled.div<{ theme: Theme }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 150vw;
  height: 150vh;
  background: ${getColor('backgroundTertiary')}4D;
  z-index: 999999;
`;

export const ModalTitle = styled(Heading)`
  text-align: center;
  margin: 0;

  @media (${breakpoint.mdMin}) {
    line-height: 38px;
  }
`;

export const Dialog = styled.div<{ theme: Theme }>`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  background: ${getColor('surfaceWhite')};
  width: calc(100% - 48px);
  height: max-content;
  min-height: 200px;
  max-width: 100%;
  max-height: calc( 100vh - 48px);
  padding: 32px 16px;
  display: flex;
  align-items: stretch;
  flex-flow: column;
  gap: 16px;
  max-width: 1000px;
  
  #modalContent  {
    overflow: auto;
  }

  & > div {
    font-family: ${font.graphikCond};
  }

  & > button {
    align-self: center;
    padding: 8px 60px;
  }

  @media (${breakpoint.mdMin}) {
    padding: 40px;
  }
`;

export const CloseButton = styled.button<{ theme: Theme }>`
  position: absolute;
  right: 8px;
  top: 8px;
  padding: 0 !important;
  height: 21px;
  width: 21px;
  
  ${getIcon('svg-states')};

  &::before {
    ${getIcon('close-icon', { height: 16, width: 15 })};
    background-color: ${getColor('neutralBlack')};
    margin: auto;
  }

  @media (${breakpoint.mdMin}) {
    right: 16px;
    top: 16px;
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 32px;
`;
